import { FormattedMessage } from "react-intl";

import { Text } from "@/components/atoms/Text";

type DepositMinimumSpendDetailsProps = {
  categoryPhrase: string;
};

/**
 * Minimum spend FAQ body for deposit listings where guests pay a deposit
 * at checkout and settle the remainder at the venue.
 */
export const DepositMinimumSpendDetails = ({
  categoryPhrase,
}: DepositMinimumSpendDetailsProps) => (
  <div className="tw-flex tw-flex-col tw-gap-16">
    <Text typeface="body-2">
      <FormattedMessage
        defaultMessage="The minimum is a {category} commitment for your event, shared across your entire party. It's included in the total cost of your event."
        values={{ category: categoryPhrase }}
      />
    </Text>
    <ul className="tw-list-disc tw-list-outside tw-space-y-8 tw-pl-24">
      <Text typeface="body-2" element="li">
        <FormattedMessage defaultMessage="Most venues accommodate splitting checks between you and your guests." />
      </Text>
      <Text typeface="body-2" element="li">
        <FormattedMessage defaultMessage="If your party doesn't reach the minimum, you cover the difference at the end of your event." />
      </Text>
      <Text typeface="body-2" element="li">
        <FormattedMessage defaultMessage="The minimum does not include any applicable tax or gratuity." />
      </Text>
      <Text typeface="body-2" element="li">
        <FormattedMessage defaultMessage="The venue will require a credit card on arrival to hold during your event." />
      </Text>
    </ul>
  </div>
);
